import { useStyles } from "../../../theme/appStyles";
import React, { useEffect, useMemo, useRef, useState } from "react";
import {
  Box,
  Button,
  Card,
  Dialog,
  DialogContent,
  Grid,
  IconButton,
  ImageList,
  ImageListItem,
  MenuItem,
  Step,
  StepLabel,
  Stepper,
  TextField,
  Typography,
  useMediaQuery,
    Table,
      TableBody,
      TableCell,
      TableContainer,
      TableHead,
      TableRow,
       InputAdornment,
         DialogTitle,
    DialogActions,
    Checkbox,
    Popover, 
      CircularProgress,
} from "@mui/material";
import SaveAltIcon from "@mui/icons-material/SaveAlt";
import CloseIcon from "@mui/icons-material/Close";
import { useFormik } from "formik";
import {
  useCreateModifierGrpMutation,
  useGetAllCategoryNameQuery,
  useGetAllMainModifierCategoryQuery,
  useGetLastProductIdQuery,
  useGetPrinterQuery,
  useGetProductBrandQuery,
  useGetProductTagQuery,
  useGetSubCategoryByArrayQuery,
  useGetSubCategoryByCategoryIdQuery,
  useGetModifierQuery,
  useGetCategoryQuery,
    useGetProductQuery,
} from "../../../Api/attoDeskApi";
import { useNotifier } from "../../../Core/Notifier";
import {
  ICategory,
  ILastProductId,
  IPrinter,
  IProductBrand,
  IProductPopUP,
  IModifierGrpPopUp,
  IProductTag,
  IModifierPopUp,
  ProductInfo,
  ModifierInfo
} from "../../../Api/Interface/api.interface";
import TaskAltIcon from "@mui/icons-material/TaskAlt";
import Switch, { SwitchProps } from "@mui/material/Switch";
import AddIcon from "@mui/icons-material/Add";
import { SizeOfLevelType } from "../../../Core/Enum/enum";
import CustomSwitch from "../../../Components/Switch/CustomSwitch";
import ColorLensIcon from "@mui/icons-material/ColorLens";
import { HexColorPicker } from "react-colorful";
import Barcode from "react-barcode";
import AppsIcon from "@mui/icons-material/Apps";
import CloudUploadIcon from "@mui/icons-material/CloudUpload";
import NewProductBrand from "../../ProductBrand/Edit/index";
import NewPrinter from "../../Printer/Edit/index";
import NewProductTag from "../../ProductTags/Edit/index";
import { uploadImage } from "../../../Components/UploadFile/upload";
// import ProductLoopingPopUp from "../Components/productLoopingPopUp";
import { styled, useTheme } from "@mui/material/styles";
import ChangeCircleIcon from "@mui/icons-material/ChangeCircle";
import ArrowBackIosIcon from "@mui/icons-material/ArrowBackIos";
import ArrowForwardIosIcon from "@mui/icons-material/ArrowForwardIos";
import AlertPopUp from "../../../Components/AlertPopUp/AlertPopup";
import { CiSearch } from "react-icons/ci";
import ArrowDropDownIcon from '@mui/icons-material/ArrowDropDown';

interface IProductPopup {
  openModel?: boolean;
  handleCloseDialog: (close: boolean) => void;
  data?: IModifierGrpPopUp;
}

const steps = ["Basic Details", "Looping Table", "Done"];

const IOSSwitch = styled((props: SwitchProps) => (
  <Switch focusVisibleClassName=".Mui-focusVisible" disableRipple {...props} />
))(({ theme }) => ({
  width: 62,
  height: 34,
  padding: 0,
  "& .MuiSwitch-switchBase": {
    padding: 0,
    margin: 2,
    transitionDuration: "300ms",
    "&.Mui-checked": {
      transform: "translateX(28px)",
      color: "#fff",
      "& + .MuiSwitch-track": {
        backgroundColor: theme.palette.primary,
        opacity: 1,
        border: 0,
      },
      "&.Mui-disabled + .MuiSwitch-track": {
        opacity: 0.5,
      },
    },
    "&.Mui-focusVisible .MuiSwitch-thumb": {
      color: "#33cf4d",
      border: "6px solid #fff",
    },
    "&.Mui-disabled .MuiSwitch-thumb": {
      color:
        theme.palette.mode === "light"
          ? theme.palette.grey[100]
          : theme.palette.grey[600],
    },
    "&.Mui-disabled + .MuiSwitch-track": {
      opacity: theme.palette.mode === "light" ? 0.7 : 0.3,
    },
  },
  "& .MuiSwitch-thumb": {
    boxSizing: "border-box",
    width: 30, // Increased thumb size
    height: 30, // Increased thumb size
  },
  "& .MuiSwitch-track": {
    borderRadius: 34 / 2,
    backgroundColor: theme.palette.mode === "light" ? "#757575" : "#39393D",
    opacity: 1,
    transition: theme.transitions.create(["background-color"], {
      duration: 500,
    }),
    "&::before, &::after": {
      content: '""',
      position: "absolute",
      top: "50%",
      transform: "translateY(-50%)",
      width: 16,
      height: 16,
    },
    "&::before": {
      backgroundImage: `url('data:image/svg+xml;utf8,<svg xmlns="http://www.w3.org/2000/svg" height="16" width="16" viewBox="0 0 24 24"><path fill="${encodeURIComponent(
        theme.palette.getContrastText(theme.palette.primary.main)
      )}" d="M21,7L9,19L3.5,13.5L4.91,12.09L9,16.17L19.59,5.59L21,7Z"/></svg>')`, // Using SVG path for check
      left: 12,
    },
    "&::after": {
      backgroundImage: `url('data:image/svg+xml;utf8,<svg xmlns="http://www.w3.org/2000/svg" height="16" width="16" viewBox="0 0 24 24"><path fill="${encodeURIComponent(
        theme.palette.getContrastText(theme.palette.primary.main)
      )}" d="M19,13H5V11H19V13Z" /></svg>')`, // Using SVG path for minus
      right: 12,
    },
  },
}));

const isPrinterArray = (data: any): data is IPrinter[] => {
  return (
    Array.isArray(data) &&
    data.every(
      (item) =>
        "id" in item && "printerName" in item && "printerDescription" in item
    )
  );
};

// Image imports
const img1 = require("../../../Images/img1.jpg");
const img2 = require("../../../Images/img2.jpg");
const img3 = require("../../../Images/img3.jpg");

const ProductPopUP = ({
  openModel = false,
  handleCloseDialog,
  data,
}: IProductPopup) => {
  const classes = useStyles();
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("md"));
  const [activeStep, setActiveStep] = useState(0);
  const [showCategorySelection, setShowCategorySelection] = useState(false);
  const [newModifier, { isLoading }] = useCreateModifierGrpMutation();
  const [deleteAlert, setDeleteAlert] = useState(false);
  const [alertMessage, setAlertMessage] = useState("");
  const { showErrorMessage, showMessage } = useNotifier();
  const [overwriteChoice, setOverwriteChoice] = useState<Record<number, 'yes' | 'no'>>({});
  const [overwritePrices, setOverwritePrices] = useState<Record<number, number>>({});
  const handleClose = () => {
    handleCloseDialog(false);
  };
  const gridHeight = isMobile ? "30px" : "400px";
   const [currentSearchQueryProduct, setCurrentSearchQueryProduct] =useState<string>("");



  // const { data: categoryNameData } = useGetAllCategoryNameQuery();
  
  // const { data: productCategoryData, isLoading: productCategoryLoading } =
  //   useGetSubCategoryByCategoryIdQuery({
  //     categoryId: "currentCategoryId",
  //   });
  // const { data: productBrandData, isLoading: ProductBrandLoading } =
  //   useGetProductBrandQuery({
  //     searchText: "",
  //     isActive: true,
  //   });
  // const { data: productTagData, isLoading: ProductTagLoading } =
  //   useGetProductTagQuery({
  //     searchText: "",
  //     isActive: true,
  //   });
  // const { data: printerData, isLoading: PrinterLoading } = useGetPrinterQuery({
  //   searchText: "",
  // });

  const [selectedCategoryId, setSelectedCategoryId] = useState<number | null>(
    null
  );
  const [selectedSubCategoryId, setSelectedSubCategoryId] = useState<
    number | null
  >(null);

  const [selectedSubToSubCategoryId, setSelectedSubToSubCategoryId] = useState<
    number | null
  >(null);

  const [selectedSubToSubToSubCategoryId, setSelectedSubToSubToSubCategoryId] =
    useState<number | null>(null);

  const [openProductCategory, setOpenProductCategory] = useState(false);
  const [openProductBrand, setOpenProductBrand] = useState(false);
  const [openProductTag, setOpenProductTag] = useState(false);
  const [openPrinter, setOpenPrinter] = useState(false);
  const [selectedColor, setSelectedColor] = useState<string>("#FFFFFF");
  const [showColorPicker, setShowColorPicker] = useState(false);
  const colorPickerRef = useRef<HTMLDivElement>(null);
  const LARAVEL_API_URL = process.env.REACT_APP_LARAVEL_API;
  const [modifiers, setModifiers] = React.useState<ModifierInfo[]>([]);
const [products, setProducts] = React.useState<ProductInfo[]>([]);
  // const { data: newLastProductIdData, isLoading: lastProductIdIsLoading } =
  //   useGetLastProductIdQuery();
  const [showBarcode, setShowBarcode] = useState(false);

  const [openLoopingCategoryDialog, setOpenLoopingCategoryDialog] =
    useState(false);

  const [openGallery, setOpenGallery] = useState(false);
  const [selectedImage, setSelectedImage] = useState<File | undefined>(
    undefined
  );
  const [isImageUploading, setIsImageUploading] = useState(false);
const selectedModifierIds = modifiers.map((m) => m.modifier_id);

  // const lastProductId = useMemo(() => {
  //   return (newLastProductIdData?.data as ILastProductId)?.lastInsertedId ?? 0;
  // }, [newLastProductIdData?.data]);

  // const productBrandList = useMemo(() => {
  //   return productBrandData?.data as IProductBrand[];
  // }, [productBrandData?.data]);
  

  // const productTagList = useMemo(() => {
  //   return productTagData?.data as IProductTag[];
  // }, [productTagData?.data]);

  // const printerList: IPrinter[] = useMemo(() => {
  //   if (!printerData || !isPrinterArray(printerData.data)) {
  //     return [];
  //   }
  //   return printerData.data;
  // }, [printerData]);

  const { data: subCategoryData, refetch: refetchSubCategories } =
    useGetSubCategoryByArrayQuery({
      parent_ids: selectedCategoryId ? [Number(selectedCategoryId)] : [],
    });

  const { data: subCategory2Data, refetch: refetchS2bCategories } =
    useGetSubCategoryByArrayQuery({
      parent_ids: selectedSubCategoryId
        ? [Number(selectedCategoryId), Number(selectedSubCategoryId)]
        : [],
    });
    const [searchText, setSearchText] = useState("");
    const [selectedRows, setSelectedRows] = useState<Record<number, boolean>>({});
    
    // For dropdown menu
    const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);
    
    
    // For Price Dialog
    const [openPriceDialog, setOpenPriceDialog] = useState(false);
    const [priceValue, setPriceValue] = useState("");
    
      const { data: categoryData, isLoading: categoryLoading } =
        useGetCategoryQuery();

    // const { data: modifierData } = useGetModifierQuery({
    //    productBrandId:  null,
    //   productCategoryId:  null,
    //   productTagIds: null,
    //   modifierViewOnline:null,
    //   createdDateEnd:  null,
    //   createdDateStart:null,
    //   searchText: null,
    //   createdDate: null,
    //   id:  "",
    //   });
    

  const { data: subCategory3Data, refetch: refetchS3bCategories } =
    useGetSubCategoryByArrayQuery({
      parent_ids: selectedSubCategoryId
        ? [
            Number(selectedCategoryId),
            Number(selectedSubCategoryId),
            Number(selectedSubToSubCategoryId),
          ]
        : [],
    });

  // const [productDetails, setProductDetails] = useState({
  //   id: "",
  //   productDetailsIsLooping: false,
  //   productsDetailsLoopingConstant: "",
  //   productName: "",
  // });

   const productCategoryId = selectedSubToSubToSubCategoryId
    ? Number(selectedSubToSubToSubCategoryId)
    : selectedSubToSubCategoryId
    ? Number(selectedSubToSubCategoryId)
    : selectedSubCategoryId
    ? Number(selectedSubCategoryId)
    : selectedCategoryId
    ? Number(selectedCategoryId)
    : String("");


  const {
      data: productData,
      isLoading: productIsLoading,
      refetch: productRefetch,
    } = useGetProductQuery({
      productBrandId: null,
     productCategoryId: String(productCategoryId), 
      productTagIds: null,
      productViewOnline: null,
      createdDateStart: null,
      createdDateEnd: null,
      searchText: currentSearchQueryProduct,
      createdDate: null,
      id: null,
    });

   const productList: IProductPopUP[] = Array.isArray(productData?.data)
      ? (productData?.data as IProductPopUP[])
      : [];

 
    //   const modifierList = useMemo(() => {
    //   return modifierData?.data as IModifierPopUp[];
    // }, [modifierData?.data]);

  // const categoryGetAllList = useMemo(() => {
  //   return categoryNameData?.data as ICategory[];
  // }, [categoryNameData?.data]);

  const categoryList = useMemo(() => {
    return categoryData?.data as ICategory[];
  }, [categoryData?.data]);


  // const subCategoryList = useMemo(() => {
  //   return subCategoryData?.data as ICategory[];
  // }, [subCategoryData?.data]);

  // const subToSubCategoryList = useMemo(() => {
  //   return subCategory2Data?.data as ICategory[];
  // }, [subCategory2Data?.data]);

  // const subToSubToSubCategoryList = useMemo(() => {
  //   return subCategory3Data?.data as ICategory[];
  // }, [subCategory3Data?.data]);

  
useEffect(() => {

  if (data?.modifiers  && productList.length > 0) {
    const parsed =
      typeof data.modifiers === 'string'
        ? JSON.parse(data.modifiers)
        : data.modifiers;

       const formatted: ProductInfo[] = parsed.map((mod: any) => {
      const info = productList.find((p) => Number(p.id) === Number(mod.product_id));
      return {
        product_id: mod.product_id,
        price: mod.price,
        pos: mod.pos ?? false,
        online: mod.online ?? false,
        productName: info?.productName ?? "", // attach name here
      };
    });
    setProducts(formatted);
 if (data?.categoryId) {
      setSelectedCategoryId(Number(data.categoryId)); 
    }

  }
}, [data,productList]);

  // const coursingMap = useMemo(() => {
  //   const map = new Map();
  //   categoryGetAllList?.forEach((category) => {
  //     map.set(category.id, category.categoryName);
  //   });
  //   return map;
  // }, [categoryGetAllList]);

  const formik = useFormik({
    initialValues: {
      id: data?.id,
      categoryId: data?.categoryId,
      modifierGroupName: data?.modifierGroupName,
      minimum: data?.minimum,
      maximum: data?.maximum,
      modifiers: typeof data?.modifiers === "string" ? JSON.parse(data.modifiers) : data?.modifiers || [],
      isActive: data?.isActive ? Boolean(data?.isActive) : false,
    
    },

    onSubmit: async (values) => {
      try {
        
 const modifierDetails = products.map((mod) => ({
  product_id: mod.product_id,
  price: mod.price,
   pos: mod.pos,
  online: mod.online,
}));

      
    let forceUpdate = false;

      if (values?.id && data?.modifiers) {
        const originalMods = typeof data.modifiers === "string" ? JSON.parse(data.modifiers) : data.modifiers;

       const oldIds = originalMods.map((m: any) => Number(m.product_id));
const newIds = modifierDetails.map((m: any) => Number(m.product_id));

const structureChanged =
  oldIds.length !== newIds.length || oldIds.some((id: any) => !newIds.includes(id));


        // --- If structure changed (add/remove), force update without confirmation ---
        if (structureChanged) {
          forceUpdate = true;
        } else {
          // --- Only check value changes (price/pos/online) ---
          for (let old of originalMods) {
            const updated = modifierDetails.find(m => Number(m.product_id) === Number(old.product_id));
            if (updated) {
              if (
                Number(old.price) !== Number(updated.price) ||
                Boolean(old.pos) !== Boolean(updated.pos) ||
                Boolean(old.online) !== Boolean(updated.online)
              ) {
                forceUpdate = window.confirm(
                  "You changed modifier values. Do you want to update all products that use this modifier group?"
                );
                break;
              }
            }
          }
        }
      }

    
        const temData = {
          id: values?.id,
          categoryId: selectedCategoryId,
          modifierGroupName: values.modifierGroupName,
          minimum: values.minimum,
          maximum: values.maximum,
          modifiers: modifierDetails, 
          isActive: values.isActive,
             force_update: forceUpdate,
        };

        if (!data) {
          delete temData.id;
        }

        const addProductResponse = await newModifier(temData).unwrap();
        if (!addProductResponse.status) {
          setAlertMessage(addProductResponse.message);
          setDeleteAlert(true);
        } else {
          showMessage(addProductResponse.message);
            handleClose();
          // if (addProductResponse.data.productDetailsIsLooping) {
          //   setActiveStep(1);
          // } else {
          //   setActiveStep(2);
          // }
        }
      } catch (error) {
        showErrorMessage("Something went wrong");
      }
    },
  });

  const formValid = useMemo(() => {
    return formik.values.modifierGroupName === "" ||
      formik.values.modifierGroupName === undefined
      ? false
      : true;
  }, [formik]);

  const resizeImage = (
    file: File,
    maxWidth: number,
    maxHeight: number
  ): Promise<File> => {
    return new Promise((resolve, reject) => {
      const reader = new FileReader();
      reader.readAsDataURL(file);

      reader.onload = (event) => {
        const img = new Image();
        img.src = event.target?.result as string;

        img.onload = () => {
          const canvas = document.createElement("canvas");
          const ctx = canvas.getContext("2d");

          let width = img.width;
          let height = img.height;

          // Calculate the new dimensions while maintaining aspect ratio
          if (width > height) {
            if (width > maxWidth) {
              height *= maxWidth / width;
              width = maxWidth;
            }
          } else {
            if (height > maxHeight) {
              width *= maxHeight / height;
              height = maxHeight;
            }
          }

          canvas.width = width;
          canvas.height = height;
          ctx?.drawImage(img, 0, 0, width, height);

          canvas.toBlob((blob) => {
            if (blob) {
              const resizedFile = new File([blob], file.name, {
                type: file.type,
              });
              resolve(resizedFile);
            } else {
              reject(new Error("Canvas is empty"));
            }
          }, file.type);
        };

        img.onerror = (error) => reject(error);
      };
    });
  };

const applyBulkToggle = (field: "pos" | "online") => {
  const updated = products.map((item: ProductInfo) =>
    selectedRows[Number(item.product_id)]
      ? { ...item, [field]: !item[field] }
      : item
  );
  setProducts(updated);
};




const applyPriceUpdate = () => {
  const updated = products.map((item: ProductInfo) =>
    selectedRows[Number(item.product_id)]
      ? { ...item, price: Number(priceValue) }
      : item
  );
  setProducts(updated);
  setOpenPriceDialog(false);
};

 const handleModifierChange = (e: React.ChangeEvent<{ value: unknown }>) => {
   const value = e.target.value;
   const selectedIds =
     typeof value === "string"
       ? value.split(',').map(Number)
       : (value as number[]);
 
   const newModifiers = selectedIds.map((id) => {
     const existing = modifiers.find((m) => m.modifier_id === id);
     return existing ?? {
       modifier_id: id,
       overwrite: false,
       overwrite_price: null,
     };
   });
 
   setModifiers(newModifiers);
 };

const handleAddModifier = (product: IProductPopUP) => {
  const alreadyAdded = products.some((m) => m.product_id === product.id);
  if (!alreadyAdded) {
    setProducts([
      ...products,
      {
        product_id: product.id,
        price: null,
        pos: false,
        online: false,
        productName: product.productName || "", 
        
      },
    ]);
  }
};


  const handleImageChange = async (
    event: React.ChangeEvent<HTMLInputElement>
  ) => {
    const files = event.target.files;

    if (files && files.length > 0) {
      const file = files[0];
      const validTypes = ["image/jpeg", "image/png", "image/jpg", "image/gif"];
      const maxSize = 2048 * 1024;

      if (!validTypes.includes(file.type)) {
        showErrorMessage("The file must be an image (jpeg, png, jpg, gif).");
        setSelectedImage(undefined);
      } else if (file.size > maxSize) {
        showErrorMessage("The file must be smaller than 2 MB.");
        setSelectedImage(undefined);
      } else {
        try {
          const resizedImage = await resizeImage(file, 500, 500);
          setSelectedImage(resizedImage);
        } catch (error) {
          showErrorMessage("Failed to resize the image.");
          setSelectedImage(undefined);
        }
      }
    } else {
      setSelectedImage(undefined);
    }
  };

  const handleGallerySelection = (selectedImage: string) => {
    fetch(selectedImage)
      .then((res) => res.blob())
      .then((blob) => {
        const file = new File([blob], "image.jpg", { type: blob.type });
        setSelectedImage(file);
      });
    setOpenGallery(false);
  };

  const openGalleryDialog = () => {
    setOpenGallery(true);
  };

  const closeGalleryDialog = () => {
    setOpenGallery(false);
  };

  const galleryImages = [img2, img3, img2, img3, img2, img3];

  
  const handleMainCategoryChange = (
    event: React.ChangeEvent<{ value: unknown }>
  ) => {
    const categoryId = event.target.value as number;
    setSelectedCategoryId(categoryId);
    setSelectedSubCategoryId(null);
    setSelectedSubToSubCategoryId(null);
    setSelectedSubToSubToSubCategoryId(null);
    formik.setFieldValue("mainCatId", categoryId);

    const selectedCategory = categoryList.find(
      (category) => category.id == categoryId
    );

    if (selectedCategory) {
      formik.setFieldValue(
        "productDetailsIsLooping",
        selectedCategory.categoryIsLooping
      );
      formik.setFieldValue(
        "productsDetailsLoopingConstant",
        selectedCategory.categoryLoopingConstant
      );
    }
  };

  // const handleSubCategoryChange = (
  //   event: React.ChangeEvent<{ value: unknown }>
  // ) => {
  //   const subCategoryId = event.target.value as number;
  //   setSelectedSubCategoryId(subCategoryId);
  //   setSelectedSubToSubCategoryId(null);
  //   setSelectedSubToSubToSubCategoryId(null);

  //   const selectedCategory = subCategoryList.find(
  //     (category) => category.id == subCategoryId
  //   );

  //   if (selectedCategory) {
  //     formik.setFieldValue(
  //       "productDetailsIsLooping",
  //       selectedCategory.categoryIsLooping
  //     );
  //     formik.setFieldValue(
  //       "productsDetailsLoopingConstant",
  //       selectedCategory.categoryLoopingConstant
  //     );
  //   }
  // };

  // const handleSubToSubCategoryChange = (
  //   event: React.ChangeEvent<{ value: unknown }>
  // ) => {
  //   const selectedSubToSubCategoryId = event.target.value as number;
  //   setSelectedSubToSubCategoryId(selectedSubToSubCategoryId);
  //   setSelectedSubToSubToSubCategoryId(null);

  //   const selectedCategory = subToSubCategoryList.find(
  //     (category) => category.id == selectedSubToSubCategoryId
  //   );

  //   if (selectedCategory) {
  //     formik.setFieldValue(
  //       "productDetailsIsLooping",
  //       selectedCategory.categoryIsLooping
  //     );
  //     formik.setFieldValue(
  //       "productsDetailsLoopingConstant",
  //       selectedCategory.categoryLoopingConstant
  //     );
  //   }
  // };

  // const handleSubToSubToSubCategoryChange = (
  //   event: React.ChangeEvent<{ value: unknown }>
  // ) => {
  //   const selectedSubToSubToSubCategoryId = event.target.value as number;
  //   setSelectedSubToSubToSubCategoryId(selectedSubToSubToSubCategoryId);

  //   const selectedCategory = subToSubToSubCategoryList.find(
  //     (category) => category.id == selectedSubToSubToSubCategoryId
  //   );

  //   if (selectedCategory) {
  //     formik.setFieldValue(
  //       "productDetailsIsLooping",
  //       selectedCategory.categoryIsLooping
  //     );
  //     formik.setFieldValue(
  //       "productsDetailsLoopingConstant",
  //       selectedCategory.categoryLoopingConstant
  //     );
  //   }
  // };

  // const handleBack = () => {
  //   setActiveStep((prevActiveStep) => prevActiveStep - 1);
  // };


  // const handleShowCategorySelection = () => {
  //   setShowCategorySelection(true);
  // };

  

  return (
    <Dialog
      open={openModel} onClose={handleClose}
      PaperProps={{
        style: {
          maxWidth: "1700px",
        },
      }}
    >
      <Grid className={classes.Dialog}>
       <Grid container spacing={3}>
              <Grid item lg={4} md={4} sm={12} xs={12}>
                <Card className={classes.stepperCard}  sx={{ mb: 2 }}>
                  <Grid
                    container
                    justifyContent={"space-between"}
                    spacing={5}
                    sx={{ borderBottom: 2, padding: 2 }}
                    className={classes.titleGrid}
                  >
                    <Grid
                      item
                      lg={12}
                      md={12}
                      sm={12}
                      xs={12}
                      pt={2}
                      alignContent={"center"}
                    >
      
      <Grid container spacing={3} p={"5px"}>
                        <Grid item lg={12} md={12} sm={12} xs={12}>
                              <Grid container alignItems="center">
                      <TextField
                         label="Modifier Group Name"
                                    // placeholder="Enter Modifier Group Name"
                                    size="small"
                                    {...formik.getFieldProps("modifierGroupName")}
                                    className={classes.textField}
                                    InputProps={{
                                      sx: {
                                        fontSize: 14,
                                      },
                                    }}
                                    InputLabelProps={{
                                      sx: {
                                        fontSize: 14,
                                      },
                                    }}
                                  />
                                  </Grid>
                                  </Grid>

                                          {/* <Grid item lg={12} md={12} sm={12} xs={12}>
                                                          <Grid container alignItems="center">
                                                  <TextField
                                                   label="Minimum"
                                                                // placeholder="Enter Minimum"
                                                                size="small"
                                                                {...formik.getFieldProps("minimum")}
                                                                type="number"
                                                                className={classes.textField}
                                                                InputProps={{
                                                                  sx: {
                                                                    fontSize: 14,
                                                                  },
                                                                }}
                                                                InputLabelProps={{
                                                                  sx: {
                                                                    fontSize: 14,
                                                                  },
                                                                }}
                                                              />
                                                              </Grid>
                                                              </Grid>
                                  
                                                                        <Grid item lg={12} md={12} sm={12} xs={12}>
                                                          <Grid container alignItems="center">
                                                  <TextField
                                                                label="Maximum"
                                                                // placeholder="Enter Maximum"
                                                                type="number"
                                                                size="small"
                                                                {...formik.getFieldProps("maximum")}
                                                                className={classes.textField}
                                                                InputProps={{
                                                                  sx: {
                                                                    fontSize: 14,
                                                                  },
                                                                }}
                                                                InputLabelProps={{
                                                                  sx: {
                                                                    fontSize: 14,
                                                                  },
                                                                }}
                                                              />
                                                              </Grid>
                                                              </Grid> */}
      
                                   <Grid item lg={12} md={12} sm={12} xs={12}>
                              <Grid container alignItems="center">
      
                                      <TextField
                                         label="Category"
                                                         select
                                                         fullWidth
                                                         size="small"
                                                         className={classes.textField}
                                                         value={selectedCategoryId ?? ""}
                                                         onChange={handleMainCategoryChange}
                                                         InputLabelProps={{ shrink: true }}
                                                       >
                                                         <MenuItem
                                                           value=""
                                                          
                                                           style={{ color: "gray" }}
                                                         >
                                                           Select Category
                                                         </MenuItem>
                                                         {categoryList &&
                                                           categoryList
                                                           .filter((category) => !category.parent_ids || category.parent_ids.length === 0) 
                                                           .map((category) => (
                                                             <MenuItem
                                                               key={category.id}
                                                               value={category.id}
                                                             >
                                                               {category.categoryName}
                                                             </MenuItem>
                                                           ))}
                                                       </TextField>
                                                       </Grid></Grid>
      
      
      
        <Grid item lg={12} md={12} sm={12} xs={12}>
                              <Grid container alignItems="center">
                    <TextField
                      InputProps={{
                        startAdornment: (
                          <InputAdornment position="start">
                            <CiSearch className={classes.searchWidgetIcon} />
                          </InputAdornment>
                        ),
                        classes: {
                          root: classes.formControlList,
                        },
                      }}
                      fullWidth
                      value={searchText}
                      onChange={(e) => setSearchText(e.target.value)}
                      placeholder="Search product.."
                      sx={{ width: "100%" }}
                      size="small"
                    />
                  </Grid>
        </Grid>
        
      
                </Grid>
      
      
                    </Grid>
                  </Grid>
                </Card>
      
      
                 <Card className={classes.stepperCard} sx={{height: 280, overflowY: 'auto'}}>
                <Grid
                            container
                            justifyContent={"space-between"}
                            spacing={5}
                            sx={{ borderBottom: 2, padding: 2 }}
                            className={classes.titleGrid}
                          >
                            <Grid
                              item
                              lg={12}
                              md={12}
                              sm={12}
                              xs={12}
                              pt={2}
                              alignContent={"center"}
                            >
                              <Typography className={classes.cardTitle}>
                             Product List
                              </Typography>
                            </Grid>
                          </Grid>
      
                          <Grid container spacing={3} p={"5px"}>
                                               
      
              {selectedCategoryId && (
        <Grid item lg={12} md={12} sm={12} xs={12}>
      <Box sx={{ padding: 2 }}> 
        {(() => { 
      
              // Step 1: Collect all child category IDs including itself
              const relatedCategoryIds = [
                Number(selectedCategoryId),
                ...categoryList
                  .filter(
                    (cat) =>
                      cat.parent_ids &&
                      Array.isArray(cat.parent_ids) &&
                      cat.parent_ids.includes(Number(selectedCategoryId))
                  )
                  .map((cat) => Number(cat.id)),
              ];
      
              // Step 2: Filter products belonging to any of these categories
          const filtered = productList.filter(
  (mod) =>
    relatedCategoryIds.includes(Number(mod.productCategoryId)) &&
    mod.isModifier &&
    mod.productName.toLowerCase().includes(searchText.toLowerCase()) &&
    !products.some((p) => Number(p.product_id) === Number(mod.id))
);

      
      
      
              return filtered.length > 0 ? (
                filtered.map((mod) => (
                  <Box
                    key={mod.id}
                    display="flex"
                    justifyContent="space-between"
                    alignItems="center"
                    mb={1}
                  >
                    <Typography>{mod.productName}</Typography>
                    <Button
                      variant="outlined"
                      size="small"
                      onClick={() => handleAddModifier(mod)}
                    >
                      Add
                    </Button>
                  </Box>
                ))
              ) : (
                <Typography
                  sx={{ textAlign: "center", padding: 2}}
                >
                  No products found
                </Typography>
              );
            })()}
          </Box>
        </Grid>
      )}
      
                        
       
                          </Grid>
                        </Card>
                      </Grid>
      
                    
              
              <Grid item lg={8} md={8} sm={12} xs={12}>
               
                  <Grid container>
                    <Grid item lg={12} md={12} sm={12} xs={12}>
                      <Card className={classes.card} sx={{ height:500, overflowY: 'auto' }}>
                        <Grid
                          container
                          justifyContent={"space-between"}
                          spacing={5}
                          sx={{ borderBottom: 2, padding: 2 }}
                          className={classes.titleGrid}
                        >
                          <Grid item lg={4} md={4} sm={4} xs={4} pt={2} alignContent={"center"}>
                            <Typography className={classes.cardTitle}>
                             Modifier
                            </Typography>
                          </Grid>
      
        <Grid
                item
                lg={8}
                md={8}
                sm={8}
                xs={8}
                sx={{ display: "flex", justifyContent: "flex-end" }}
              >
                <Grid
                  container
                  spacing={1}
                  justifyContent="flex-end"
                  sx={{ display: "flex" }}
                >
                 
                  <Grid item>
                    <Button
                      variant="contained"
                      className={classes.addButton}
                      endIcon={<ArrowDropDownIcon />}
                       onClick={(e) => setAnchorEl(e.currentTarget)}
                    >
                      Edit
                    </Button>
                  </Grid>
                </Grid>
              </Grid>
      
                        </Grid>
      
      
      
         {selectedCategoryId && (
                
        <Grid>
           
           <TableContainer>
          <Table className={classes.table}>
            <TableHead className={classes.tableHeaderRow}>
              <TableRow>
                <TableCell className={classes.tablheader}><strong>Product Name</strong></TableCell>
                <TableCell className={classes.tablheader}><strong>Price</strong></TableCell>
                  <TableCell className={classes.tablheader}><strong>Online</strong></TableCell>
                    <TableCell className={classes.tablheader}><strong>POS</strong></TableCell>
                {/* <TableCell className={classes.tablheader}><strong>Overwrite?</strong></TableCell>
                <TableCell className={classes.tablheader}><strong>Overwrite Price</strong></TableCell> */}
                <TableCell className={classes.tablheader}><strong>Action</strong></TableCell>
                  <TableCell className={classes.tablheader}>
                      <Checkbox
        checked={
          products.length > 0 &&
          products.every((item) => selectedRows[Number(item.product_id)])
        }
        indeterminate={
          products.some((item) => selectedRows[Number(item.product_id)]) &&
          !products.every((item) => selectedRows[Number(item.product_id)])
        }
        onChange={(e: React.ChangeEvent<HTMLInputElement>) => {
          const newSelected: Record<number, boolean> = {};
          if (e.target.checked) {
            products.forEach((item: ProductInfo) => {
              newSelected[Number(item.product_id)] = true;
            });
          }
          setSelectedRows(newSelected);
        }}
      />
      
      
      
                                </TableCell>
              </TableRow>
            </TableHead>
          <TableBody>
        {products.map((mod, index) => {
          const modInfo = productList.find((m) => m.id === mod.product_id);
    
          return (
            <TableRow key={mod.product_id}>
              <TableCell>{mod.productName}</TableCell>
          <TableCell>
        <TextField
          type="number"
          size="small"
          value={mod.price || ""}
           onChange={(e) => {
        const updated = [...products];
        updated[index] = {
          ...updated[index],
          price: Number(e.target.value),
        };
      
        setProducts(updated);
      }}
        
          sx={{ width: 100 }}
        />
      </TableCell>
      
             <TableCell>
        <IOSSwitch
          checked={mod.online ?? false}
          onChange={(event: React.ChangeEvent<HTMLInputElement>) => {
            const updated = [...products];
            updated[index] = {
              ...updated[index],
              online: event.target.checked, //  use checked
            };
            setProducts(updated);
          }}
        />
      </TableCell>
      
      {/* POS SWITCH */}
      <TableCell>
        <IOSSwitch
          checked={mod.pos ?? false}
          onChange={(event: React.ChangeEvent<HTMLInputElement>) => {
            const updated = [...products];
            updated[index] = {
              ...updated[index],
              pos: event.target.checked, 
            }
            setProducts(updated);
          }}
        />
      </TableCell>
      
            
              <TableCell>
                 <IconButton
          size="small"
          color="error"
          onClick={() => {
            const updated = products.filter(
              (item) => item.product_id !== mod.product_id
            );
            setProducts(updated);
          }}
            sx={{
            backgroundColor: '#f8d7da',
            borderRadius: '50%',
            padding: '4px',
            '&:hover': {
              backgroundColor: '#f1b0b7',
            },
          }}
        >
          <CloseIcon fontSize="small" />
        </IconButton>
              </TableCell>
      
                <TableCell className={classes.tablCell}>
                          <Checkbox
        checked={selectedRows[Number(mod.product_id)] || false}
        onChange={(e: React.ChangeEvent<HTMLInputElement>) => {
          setSelectedRows({
            ...selectedRows,
            [Number(mod.product_id)]: e.target.checked,
          });
        }}
      />
      
      
      
      
                                    </TableCell>
            </TableRow>
          );
        })}
      </TableBody>
      
          </Table>
          </TableContainer>
        
        </Grid>
           )}
      
      
                      </Card>
                    </Grid>
      
                 
                  </Grid>
             
              </Grid>
      
      
      
      
      
        <Grid item lg={12} md={12} sm={12} xs={12} pt={3}>
                        <Card className={classes.card}>
                          <Grid container spacing={3} p={"24px"}>
                            <Grid
                              item
                              lg={12}
                              md={12}
                              sm={12}
                              xs={12}
                              sx={{ display: "flex", justifyContent: "flex-end" }}
                            >
                              <Button
                                variant="outlined"
                                startIcon={<CloseIcon />}
                                className={classes.addButton}
                                onClick={handleClose}
                              >
                                Cancel
                              </Button>
                              <Box m={0.5}></Box>
      
                              <Button
                                variant="contained"
                                startIcon={<SaveAltIcon />}
                                className={classes.addButton}
                                onClick={() => formik.handleSubmit()}
                                disabled={!formValid || isLoading}
                              >
                                Save
                              </Button>
                            </Grid>
                          </Grid>
                </Card>
                
              </Grid>
      
            </Grid>
      
      <Popover
        open={Boolean(anchorEl)}
        anchorEl={anchorEl}
        onClose={() => setAnchorEl(null)}
        anchorOrigin={{ vertical: "bottom", horizontal: "left" }}
      >
        <MenuItem
          onClick={() => {
            setAnchorEl(null);
            setOpenPriceDialog(true);
          }}
        >
          Price
        </MenuItem>
      
        <MenuItem
          onClick={() => {
            applyBulkToggle("pos");
            setAnchorEl(null);
          }}
        >
          POS
        </MenuItem>
      
        <MenuItem
          onClick={() => {
            applyBulkToggle("online");
            setAnchorEl(null);
          }}
        >
          Online
        </MenuItem>
      </Popover>
      
      <Dialog open={openPriceDialog} onClose={() => setOpenPriceDialog(false)}>
        <DialogTitle>Update Price</DialogTitle>
      
        <DialogContent>
          <TextField
            label="Enter Price"
            type="number"
            fullWidth
            size="small"
            value={priceValue}
            onChange={(e) => setPriceValue(e.target.value)}
          />
        </DialogContent>
      
        <DialogActions>
          <Button onClick={() => setOpenPriceDialog(false)}>Cancel</Button>
      
          <Button variant="contained" onClick={applyPriceUpdate}>
            Apply
          </Button>
        </DialogActions>
      </Dialog>
      </Grid>
    </Dialog>
  );
};

export default ProductPopUP;
